import React, { useState } from "react";

export default function DeleteButton({ item, viewName = "item", onDelete }) {
  const [open, setOpen] = useState(false);

  const handleDelete = async () => {
    await onDelete(item); // send whole item
    setOpen(false);
  };

  return (
    <>
      {/* Delete Button */}
      <button
        onClick={() => setOpen(true)}
        style={{
          padding: "4px 10px",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          background: "#dc3545",
          color: "white",
          fontSize: "13px",
        }}
      >
        Delete
      </button>

      {/* Confirmation Modal */}
      {open && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backdropFilter: "blur(2px)",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: "350px",
              background: "white",
              padding: "20px",
              borderRadius: "10px",
              textAlign: "center",
              boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
            }}
          >
            <h3 style={{ marginBottom: "15px", fontSize: "18px" }}>
              Delete {viewName}?
            </h3>

            <p style={{ marginBottom: "25px" }}>
              Are you sure you want to delete this {viewName}?
            </p>

            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
              <button
                onClick={handleDelete}
                style={{
                  padding: "8px 14px",
                  background: "#dc3545",
                  border: "none",
                  color: "white",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Delete
              </button>

              <button
                onClick={() => setOpen(false)}
                style={{
                  padding: "8px 14px",
                  background: "#6c757d",
                  border: "none",
                  color: "white",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
